import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import { useAddToCart } from '../../../api/shoppingCart';
import AddToCartButtonToQty from '../../../components/AddToCartButtonToQty';

export interface CataloguePageListContentItemRowAddToCartProps
  extends StandardDivProps<CataloguePageListContentItemRowAddToCartClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemRowAddToCartClassKey = 'root';

const themeSettings = { name: 'CataloguePageListContentItemRowAddToCart' };
const useStyles = makeStyles(
  createStyles<CataloguePageListContentItemRowAddToCartClassKey | 'qfWrapper', {}>({
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    qfWrapper: {
      justifyContent: 'flex-end',
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowAddToCart = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemRowAddToCartProps
>(({ className, classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });

  const { addToCart, ...addToCartProps } = useAddToCart({
    forcePreventDecrement: true,
    product,
  });

  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      <AddToCartButtonToQty
        onAddToCart={addToCart}
        {...addToCartProps}
        product={product}
        QuantityFieldProps={{
          classes: {
            wrapper: classes.qfWrapper,
          },
        }}
      />
    </div>
  );
});

CataloguePageListContentItemRowAddToCart.displayName = 'CataloguePageListContentItemRowAddToCart';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowAddToCart);
